// src/maincomponents/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="fixed bottom-0 inset-x-0 bg-transparent z-30">
      <div className="max-w-screen-xl mx-auto px-4 py-4 text-deepIndigo font-Merriweather text-xs sm:text-sm text-center flex items-center justify-center leading-none">
        <p className="m-0">
          &copy; {new Date().getFullYear()} Realalfa Financial Inc. A Real Estate Consulting Company. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
